"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ignore
 */
class BigSegmentStoreStatusProviderImpl {
    constructor(onRequestStatus) {
        this.onRequestStatus = onRequestStatus;
    }
    /**
     * Gets the current status of the store, if known.
     *
     * @returns a {@link BigSegmentStoreStatus}, or `undefined` if the SDK has not yet queried the
     *   Big Segment store status
     */
    getStatus() {
        return this.lastStatus;
    }
    /**
     * Gets the current status of the store, querying it if the status has not already been queried.
     *
     * @returns a Promise for the status of the store
     */
    async requireStatus() {
        if (!this.lastStatus) {
            await this.onRequestStatus();
        }
        // Status will be defined at this point.
        return this.lastStatus;
    }
    notify() {
        var _a;
        if (this.lastStatus) {
            (_a = this.listener) === null || _a === void 0 ? void 0 : _a.call(this, this.lastStatus);
        }
    }
    setListener(listener) {
        this.listener = listener;
    }
    setStatus(status) {
        this.lastStatus = status;
    }
}
exports.default = BigSegmentStoreStatusProviderImpl;
//# sourceMappingURL=BigSegmentStatusProviderImpl.js.map